"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER = exports.FAMILY_FRIENDS = exports.UTILITIES = exports.COLLECTION = exports.AUTOMOBILE = exports.MEDICAL = exports.PENSION_PROFIT_SHARE = exports.JUDGMENT = exports.CREDIT_CARD = exports.SEPARATION = exports.EDUCATION = exports.RESTITUTION = exports.PERSONAL_INJURY = exports.GOVERNMENT = exports.DOMESTIC_SUPPORT = exports.MORTGAGE = void 0; // -- Secured --

var MORTGAGE = 'mortgage'; // -- Priority Unsecured --

exports.MORTGAGE = MORTGAGE;
var DOMESTIC_SUPPORT = 'domestic_support';
exports.DOMESTIC_SUPPORT = DOMESTIC_SUPPORT;
var GOVERNMENT = 'government'; // Taxes, Court Fees, Incarceration Fees

exports.GOVERNMENT = GOVERNMENT;
var PERSONAL_INJURY = 'personal_injury';
exports.PERSONAL_INJURY = PERSONAL_INJURY;
var RESTITUTION = 'restitution'; // -- Non-Priority Unsecured --

exports.RESTITUTION = RESTITUTION;
var EDUCATION = 'education';
exports.EDUCATION = EDUCATION;
var SEPARATION = 'separation'; // Ex) divorce

exports.SEPARATION = SEPARATION;
var CREDIT_CARD = 'credit_card';
exports.CREDIT_CARD = CREDIT_CARD;
var JUDGMENT = 'judgment';
exports.JUDGMENT = JUDGMENT;
var PENSION_PROFIT_SHARE = 'pension_profit_share';
exports.PENSION_PROFIT_SHARE = PENSION_PROFIT_SHARE;
var MEDICAL = 'medical';
exports.MEDICAL = MEDICAL;
var AUTOMOBILE = 'automobile';
exports.AUTOMOBILE = AUTOMOBILE;
var COLLECTION = 'collection';
exports.COLLECTION = COLLECTION;
var UTILITIES = 'utilities';
exports.UTILITIES = UTILITIES;
var FAMILY_FRIENDS = 'family_friends'; // Not on paperwork, just for users to see as an option (and not priority)

exports.FAMILY_FRIENDS = FAMILY_FRIENDS;
var OTHER = 'other';
exports.OTHER = OTHER;